// extracted by mini-css-extract-plugin
module.exports = {"tooltip-root":"style_tooltip-root__UuEhP"};